import { ShortCode } from '@highereducation/wordpress';
import { Badge, BadgeProps } from '@highereducation/hen-ui';

interface BadgeShortcodeProps extends BadgeProps {
  variant?: 'primary' | 'light' | 'outline' | 'neutral';
  size?: 'sm' | 'lg';
  [key: string]: any;
}

export const BadgeShortcode: ShortCode<BadgeShortcodeProps> = {
  component: ({ variant = 'primary', size = 'sm', children }) => {
    return (
      <Badge variant={variant} size={size}>
        {children}
      </Badge>
    );
  },
};
